export default __webpack_public_path__ + "static/media/camera-house-mobile-one.3bc72922.png";